import { Alert, Anchor } from '@mantine/core';
import { IconFlask } from '@tabler/icons-react';

import { usePlatform } from '@/features/signup/platform-context';

/** Bandeau de la version de démonstration en ligne (jamais imprimé). */
export function DemoBanner({ onRecommend }: { onRecommend: () => void }) {
  if (!usePlatform()?.demo) return null;
  return (
    <Alert
      className="no-print"
      color="yellow"
      variant="light"
      icon={<IconFlask size={18} />}
      mb="md"
      py={8}
    >
      Version de démonstration : toutes les données sont fictives et peuvent être remises à zéro.
      Votre avis compte :{' '}
      <Anchor component="button" size="sm" fw={600} onClick={onRecommend}>
        faites vos recommandations
      </Anchor>{' '}
      pour améliorer le logiciel.
    </Alert>
  );
}
